module.exports = __webpack_public_path__ + "img/close.4786c7c1.png";